import { useLocation } from 'react-router';

export default function useShowDemoProjects() {
  const location = useLocation();
  return !!new URLSearchParams(location.search).get('demo');
}
